export const UPDATE_USER = 'update_user';
export const UPDATE_USER_SUCCESSFUL = 'update_user_successfull';
export const UPDATE_USER_FAILED = 'update_user_failed';



